<template>
  <v-dialog
    v-model="show"
    scrollable
    persistent
    maxWidth="500"
    :noClickAnimation="true"
  >
    <v-card>
      <v-card-title class="modal-title">
        <v-row class="m-0">
          <v-col class="p-0">
            <h4 class="modal-title-text">
              <v-icon
                size="40"
                color="#ffffff"
              >
                mdi-information-outline
              </v-icon>
              <span style="color: #fff; font-size: 22px;">
                {{ $t(title) }}
              </span>
            </h4>
          </v-col>
        </v-row>
      </v-card-title>

      <v-divider />

      <v-card-text class="pt-4">
        <p class="modal-message">
          {{ $t(message) }}
        </p>
      </v-card-text>

      <v-card-actions class="justify-center pb-4">
        <v-btn
          class="modal-btn"
          color="#2A3E53"
          @click="redirectToHome"
        >
          {{ $t(buttonText) }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: 'redirectModal.title',
        },
        message: {
            type: String,
            default: 'redirectModal.message',
        },
        buttonText: {
            type: String,
            default: 'forceUpdate.continue',
        },
    },

    methods: {
        redirectToHome() {
            this.$emit('close');
            this.$router.push('/');
        },
    },
};
</script>

<style scoped lang="scss">
.modal-title {
  background: #2A3E53;
  padding: 10px;

  &-text {
    display: flex;
    align-items: center;
    column-gap: 10px;
  }
}

.modal-message {
  padding: 10px;
  font-size: 16px;
  text-align: center;
}

.modal-btn {
  color: white;
  min-width: 120px;
  border-radius: 20px;
  text-transform: none;
  font-size: 16px;
  letter-spacing: normal;
}
</style>
